<div class="filtros-dialog">
  <h2 mat-dialog-title>
    <mat-icon>filter_list</mat-icon>
    Filtros de Búsqueda
  </h2>

  <mat-dialog-content>
    <form [formGroup]="filtrosForm" *ngIf="!isLoading">

      <!-- TIPOS DE CONTENIDO -->
      <mat-card class="filter-section">
        <mat-card-header>
          <mat-card-title>Tipos de Contenido</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="checkbox-group">
            <mat-checkbox formControlName="showEscritos">
              Mostrar Escritos
            </mat-checkbox>
            <mat-checkbox formControlName="showPlantillas">
              Mostrar Plantillas
            </mat-checkbox>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- TIPOS DE ESCRITO -->
      <mat-card class="filter-section">
        <mat-card-header>
          <mat-card-title>Tipos de Escrito</mat-card-title>
          <div class="card-actions">
            <button
              type="button"
              mat-icon-button
              (click)="toggleAll('tiposEscrito', tiposEscrito)"
              [matTooltip]="isAllSelected('tiposEscrito', tiposEscrito) ? 'Deseleccionar todos' : 'Seleccionar todos'">
              <mat-icon>
                {{ isAllSelected('tiposEscrito', tiposEscrito) ? 'check_box' :
                   isIndeterminate('tiposEscrito', tiposEscrito) ? 'indeterminate_check_box' : 'check_box_outline_blank' }}
              </mat-icon>
            </button>
          </div>
        </mat-card-header>
        <mat-card-content>
          <div class="checkbox-list">
            <mat-checkbox
              *ngFor="let tipo of tiposEscrito"
              [value]="tipo.id"
              formControlName="tiposEscrito">
              {{ tipo.descripcion }}
            </mat-checkbox>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- ESTADOS DE ESCRITO -->
      <mat-card class="filter-section">
        <mat-card-header>
          <mat-card-title>Estados</mat-card-title>
          <div class="card-actions">
            <button
              type="button"
              mat-icon-button
              (click)="toggleAll('estadosEscrito', estadosEscrito)"
              [matTooltip]="isAllSelected('estadosEscrito', estadosEscrito) ? 'Deseleccionar todos' : 'Seleccionar todos'">
              <mat-icon>
                {{ isAllSelected('estadosEscrito', estadosEscrito) ? 'check_box' :
                   isIndeterminate('estadosEscrito', estadosEscrito) ? 'indeterminate_check_box' : 'check_box_outline_blank' }}
              </mat-icon>
            </button>
          </div>
        </mat-card-header>
        <mat-card-content>
          <div class="checkbox-list">
            <mat-checkbox
              *ngFor="let estado of estadosEscrito"
              [value]="estado.id"
              formControlName="estadosEscrito">
              {{ estado.descripcion }}
            </mat-checkbox>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- FECHAS -->
      <mat-card class="filter-section">
        <mat-card-header>
          <mat-card-title>Rango de Fechas</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="date-range">
            <mat-form-field appearance="outline" class="date-field">
              <mat-label>Desde</mat-label>
              <input matInput [matDatepicker]="pickerDesde" formControlName="fechaDesde">
              <mat-datepicker-toggle matSuffix [for]="pickerDesde"></mat-datepicker-toggle>
              <mat-datepicker #pickerDesde></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="date-field">
              <mat-label>Hasta</mat-label>
              <input matInput [matDatepicker]="pickerHasta" formControlName="fechaHasta">
              <mat-datepicker-toggle matSuffix [for]="pickerHasta"></mat-datepicker-toggle>
              <mat-datepicker #pickerHasta></mat-datepicker>
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- CREADO POR -->
      <mat-card class="filter-section">
        <mat-card-header>
          <mat-card-title>Creado Por</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nombre del usuario</mat-label>
            <input matInput formControlName="creadoPor" placeholder="Buscar por nombre...">
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </form>

    <!-- LOADING -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Cargando opciones...</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onReset()" type="button">
      <mat-icon>refresh</mat-icon>
      Limpiar
    </button>
    <button mat-button (click)="onCancel()" type="button">
      Cancelar
    </button>
    <button mat-raised-button color="primary" (click)="onApply()" type="button">
      <mat-icon>check</mat-icon>
      Aplicar Filtros
    </button>
  </mat-dialog-actions>
</div>
